var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_vm._v("PARA ISLEMLERININ LISTELENDIGI EKRAN")])}
var staticRenderFns = []

export { render, staticRenderFns }